export default __webpack_public_path__ + "static/media/Mapping.99bfc3c4.svg";